import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzMessageService } from 'ng-zorro-antd/message';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { AuthService } from '../services/auth.service';
import { finalize } from 'rxjs/operators';

@Component({
  selector: 'app-mobile-desktop',
  standalone: true,
  imports: [CommonModule, NzButtonModule, TranslateModule],
  templateUrl: './mobile-desktop.component.html',
  styleUrl: './mobile-desktop.component.less',
})
export class MobileDesktopComponent implements OnInit {
  desktopLink = '';
  isCopyLoading = false;
  isEmailLoading = false;
  isPlatformAdmin = false;

  constructor(
    private message: NzMessageService,
    private translate: TranslateService,
    private authService: AuthService
  ) {}

  ngOnInit(): void {
    this.isPlatformAdmin = this.authService.isCurrentUserAdmin();
  }

  private ensureDesktopLink(onReady: (link: string) => void): void {
    // If we already fetched it, reuse it (avoid generating multiple tokens)
    if (this.desktopLink) {
      onReady(this.desktopLink);
      return;
    }

    this.isCopyLoading = true;

    this.authService
      .getDesktopLoginLink()
      .pipe(finalize(() => (this.isCopyLoading = false)))
      .subscribe({
        next: (res) => {
          this.desktopLink = res.link;
          onReady(this.desktopLink);
        },
        error: () => {
          this.message.error(this.translate.instant('MOBILE_DESKTOP.LINK_ERROR'));
        },
      });
  }

  copyLink(): void {
    if (this.isPlatformAdmin) {
      return;
    }

    this.ensureDesktopLink(async (link) => {
      try {
        await navigator.clipboard.writeText(link);
        this.message.success(this.translate.instant('MOBILE_DESKTOP.COPIED'));
      } catch {
        // Fallback if clipboard API blocked
        const textarea = document.createElement('textarea');
        textarea.value = link;
        textarea.style.position = 'fixed';
        textarea.style.left = '-9999px';
        document.body.appendChild(textarea);
        textarea.select();
        document.execCommand('copy');
        document.body.removeChild(textarea);

        this.message.success(this.translate.instant('MOBILE_DESKTOP.COPIED'));
      }
    });
  }

  emailLink(): void {
    if (this.isPlatformAdmin) {
      return;
    }

    this.isEmailLoading = true;

    this.authService
      .emailDesktopLoginLink()
      .pipe(finalize(() => (this.isEmailLoading = false)))
      .subscribe({
        next: () => {
          this.message.success(this.translate.instant('MOBILE_DESKTOP.EMAIL_SENT'));
        },
        error: () => {
          this.message.error(this.translate.instant('MOBILE_DESKTOP.EMAIL_ERROR'));
        },
      });
  }

  logout(): void {
    this.authService.logout();
  }
}
